import React from "react";
import { useMasterList } from "@/hooks/useMasterData";
import { badgeStyle } from "@/lib/badgeColor";

// Renders a colored taxonomy badge. Resolves the value's Badge Color from the
// master-data list (by id or label) and derives bg/text/border from that single hex.
// Pass `color` directly to skip the lookup.
export default function TonalBadge({ listType, label, id, color, fallback = "—", className = "", testid }) {
  const { data = [] } = useMasterList(listType);
  let resolved = color;
  let text = label;
  if (id != null || label != null) {
    const v = id != null ? data.find((d) => d.id === id) : data.find((d) => d.label === label);
    if (resolved == null) resolved = v?.badge_color;
    if (text == null) text = v?.label;
  }
  if (text == null || text === "") {
    return <span className="text-slate-300">{fallback}</span>;
  }
  return (
    <span
      style={badgeStyle(resolved)}
      className={`inline-flex items-center px-2.5 py-0.5 rounded-full text-[11px] font-semibold border ${className}`}
      data-testid={testid || `tonal-badge-${String(text).toLowerCase().replace(/[^a-z0-9]+/g, "-").replace(/^-|-$/g, "")}`}
    >
      {text}
    </span>
  );
}
